import _ from 'lodash';

const DEFAULT_EVENT_TYPE = 'default';

class MultiLangSameValueDirective {
  constructor() {
    this.restrict = 'A';
    this.require = 'ngModel';
    this.scope = {
      locales: '<',
      fieldPath: '@',
      fieldModel: '=',
      eventType: '@?',
    };
  }

  link(scope, element, attr, ngModelCtrl) {
    const eventType = scope.eventType ? scope.eventType : DEFAULT_EVENT_TYPE;
    this[`link_${eventType}`](scope, element, ngModelCtrl);

    scope.$on('$destroy', () => {
      element.off();
    });
  }

  link_default(scope, element, ngModelCtrl) {
    // eslint-disable-line camelcase
    ngModelCtrl.$viewChangeListeners.push(() => {
      this.setFieldValue(scope, ngModelCtrl);
    });
  }

  link_click(scope, element, ngModelCtrl) {
    // eslint-disable-line camelcase
    element.on('click', () => {
      this.setFieldValue(scope, ngModelCtrl);
    });
  }

  link_hiddenField(scope, element, ngModelCtrl) {
    scope.$watch(() => ngModelCtrl.$modelValue, () => this.setFieldValue(scope, ngModelCtrl));
  }

  setFieldValue(scope, ngModelCtrl) {
    scope.locales = scope.locales.map((locale) => {
      scope.fieldModel = _.set(scope.fieldModel, `${locale.code}.${scope.fieldPath}`, ngModelCtrl.$modelValue);
      return locale;
    });
  }
}

export default MultiLangSameValueDirective;



// WEBPACK FOOTER //
// ./src/modules/utils/multilanguage/components/multi-lang-same-value-directive.js